export default "__VITE_ASSET__VYWEho5T__"